export default "__VITE_ASSET__6xFx4bUE__"